class Utils {
  static init(pageScroller, responsive) {
    this.calcul100vh();
    this.goToRdv(pageScroller);
    this.getBackgrundRdvMobile();
    this.legalContent(pageScroller);
    this.typeNumber();
    if( responsive.mobile == true) {
      this.removeRedondantWords('Espace');
    }
    if( window.innerWidth < 1260) {
      this.closeMenuMobile(pageScroller);
    }
  }

  static calcul100vh() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    window.addEventListener('resize', () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
  }

  static goToRdv(pageScroller) {
    let btns = document.querySelectorAll('.btn[href="#rdv"]');
    let rdvForm = document.querySelector('#rdv');

    btns.forEach((el) => {
      el.addEventListener('click', (e) => {
        rdvForm?.scrollIntoView({ behavior: 'smooth' });
      })
    })
  }

  static removeRedondantWords(word) {
    let mobileTabsLink = document.querySelectorAll('.nav-tabs .nav-item');
    mobileTabsLink.forEach((el) => {
      let txt = el.innerHTML;
      txt = txt.replace(word, '');
      el.innerHTML = txt;
    })
  }

  static getBackgrundRdvMobile() {
    let siteUrl = document.location.host
    let rdv = document.querySelector('#rdv');
    let imgDesktop = "https://"+ siteUrl +"/app/uploads/2022/09/rectangle-151.svg"
    let imgMobile = "https://"+ siteUrl +"/app/uploads/2022/10/rectangle-652.svg"

    if (window.innerWidth < 1280) {
      rdv.style.backgroundImage = 'url("' + imgMobile + '")';
    } else {
      rdv.style.backgroundImage = 'url("' + imgDesktop + '")';
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth < 1280) {
        rdv.style.backgroundImage = 'url("' + imgMobile + '")';
      } else {
        rdv.style.backgroundImage = 'url("' + imgDesktop + '")';
      }
    })
  }

  static legalContent(pageScroller) {
    let legalLink = document.querySelectorAll('#legal-link')
    let legalContainer = document.querySelector('.legals-container')

    if(legalContainer) {
      legalLink.forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          pageScroller.pauseSmoothScroll(true);
          legalContainer.classList.add('open')
          let closeBtn =  document.querySelector('.legals-container .close-btn')
          closeBtn.addEventListener('click', () => {
            legalContainer.classList.remove('open');
            pageScroller.pauseSmoothScroll(false);
          })
        })
      })
    }
  }

  static typeNumber() {
    let inputTypeNumber = document.querySelectorAll('input[type="number"]')
    let authorizeKeyCode = [
      "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "backspace", "delete", "tab", "enter", "arrowleft", "arrowright"
    ]
    inputTypeNumber.forEach((item) => {
      item.addEventListener('keypress', (e) => {
        if(!authorizeKeyCode.includes(e.key)) {
          e.preventDefault();
        }
      })
    })
  }

  static closeMenuMobile(pageScroller) {
    let link = document.querySelectorAll('.nav-item a.nav-link')

    link.forEach((el) => {
      el.addEventListener('click', () => {
        let menu = document.querySelector('.menu-container')
        let header = document.querySelector('header')
        let filter = document.querySelector('.filter')
        let burger = document.querySelector('.burger')
        let links = document.querySelector('.links')
        let btnContact = document.querySelector('.links .btn')
        let logoWrapper = document.querySelector('.logo-wrapper')
        logoWrapper.classList.remove('open')
        btnContact.classList.remove('btn-secondary')
        btnContact.classList.add('btn-primary')
        links.classList.remove('open')
        burger.classList.remove('open')
        menu.classList.remove('open')
        header.classList.remove('open')
        filter.classList.remove('open')
        pageScroller.pauseSmoothScroll(false);
      })
    })
  }
}

export default Utils;
